// extracted by mini-css-extract-plugin
export default {"customBtn":"zjrmjGaR"};